<script setup lang="ts">
// assets
// import emptyImage from '@images/products/empty-shopping-cart.png';
import emptyImage from '@images/products/empty-cart-t2t.png';
import storeIcon from '@images/icons/store-3d.png';
import errorNoSignal from '@images/products/error-no-signal.png';
// import emptyCartImage from '@images/lottie_files/empty-cart.json';
import { useStoresStore  } from '@/stores/apps/store';
import { useAuthStore  } from '@/stores/auth';
import { useThirdpartyStore } from '@/stores/apps/thirdparty';
import { IconAlertCircle, IconAlertCircleFilled, IconCurrentLocation, IconGpsFilled, IconHandStop } from '@tabler/icons-vue';
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()

const thirdpartyStore = useThirdpartyStore();
const store = useStoresStore();
const auth = useAuthStore();
const baseUrl = useRuntimeConfig().public.apiBase;

const selectedStore = <any>computed(() => {
    return store.getSelectedStore
})

const welcomeMessage = ref(false);
const isThirdpartySelected = computed(() => thirdpartyStore.isThirdpartySelected ? true : false);

watch(() => selectedStore.value, (value) => {
    if (value && value.name){
        welcomeMessage.value = true;
        auth.setToShowTutorial(0);
    } /* else {
        auth.setToShowTutorial(1);
    } */
})

onMounted(() => {
    if (selectedStore.value && selectedStore.value.name){
        welcomeMessage.value = true;
        auth.setToShowTutorial(0);
    } /* else {
        auth.setToShowTutorial(1);
    } */
})
</script>

<template>
    <v-row class="justify-center">
        <v-col class="text-center px-0" lg="6">
            <!-- <div v-if="selectedStore && selectedStore.name"> -->
            <div>
                <v-card class="pa-5">
                    <!-- <h4 class="text-h4 text-primary">{{ $t('Ooh no') }}</h4> -->
                     
                    <h2 class="text-h2 font-weight-bold text-primary">{{ $t('EmptyCart') }}</h2>
                    <v-img :src="emptyImage" cover :width="200" class="mx-auto my-6" />
                    <!-- <h5 class="text-h3">{{ $t('ItsToEasyPickup') }}</h5> -->
                    <!-- <div class="text-subtitle-1 text-grey-darken-5 pt-2 px-8" v-html="$t('just_pick_with_your_camera')"></div> -->
                    <div class="text-subtitle-1 text-grey-darken-5 pt-2 px-8">
                        <nuxt-link v-if="isThirdpartySelected" to="/apps/ecommerce/products" class="text-primary">Abrir catálogo</nuxt-link>
                        <nuxt-link v-else to="/apps/contacts" class="text-primary">Seleccionar cliente</nuxt-link>
                    </div>
                </v-card>
                <!-- <div class="text-grey600 pt-4 text-center align-center line-height-1"><IconCurrentLocation size="20" class="mr-1" style="margin-bottom: -5px" /> {{ selectedStore.name }}</div> -->
             </div>
            <!--<div v-else>
                <v-card class="pa-6">
                    <h4 class="text-h4 text-primary">{{ $t('Ooh no') }}</h4>
                    <h2 class="text-h2 font-weight-bold text-primary">{{ $t('NoSignal') }}</h2>
                    <v-img :src="errorNoSignal" cover :width="160" class="mx-auto my-6" />
                    <h5 class="text-h3">{{ $t('StoreIsNotSet') }}</h5>
                    <div class="text-subtitle-1 text-grey-darken-5 pt-2 px-8" v-html="$t('check_your_gps')"></div>
                </v-card>
            </div> -->
        </v-col>
    </v-row>
</template>
<style lang="scss" scoped>
.line-height-1 {
    line-height: 1rem !important;
}
.store-logo-image {
    img, .v-img__img {
        filter: drop-shadow(2px 2px 2px 0px rgba(0, 0, 0, 0.6)) !important;
    }
}
</style>
